export default "__VITE_ASSET__b8bdb8b5__"